<template>
  <div>
    <button-new />
    <list />
  </div>
</template>

<script>
import ButtonNew from './ButtonNew'
import List from './List/index'

export default {
  components: {
    ButtonNew,
    List
  }
}
</script>
